import { bbox, featureCollection } from '@turf/turf';

function getBounds(feature1, feature2) {
  const collection = featureCollection([
    feature1, feature2,
  ]);

  return bbox(collection);
}

export {
  getBounds,
}